<template>
  <div class="devredister">
    <div class="devredister-content">
      <div class="devredister_title">开发者注册</div>
      <div class="devredister_form_wrapper">
        <el-form :model="devredisterForm" ref="devredisterForm" :rules="rules" label-width="20px" class="devredisterform">
          <el-form-item label=" " prop="mobile">
            <el-input v-model.trim="devredisterForm.mobile" autocomplete="off" placeholder="手机号" :maxlength="20" clearable>
              <i slot="prefix" class="el-input__icon icon-my-user"></i>
            </el-input>
          </el-form-item>
          <el-form-item label=" " prop="imageCode" class="image-code-item">
            <el-input v-model.trim="devredisterForm.imageCode" autocomplete="off" placeholder="图形验证码" :maxlength="10" clearable>
              <i slot="prefix" class="el-input__icon icon-my-validcode"></i>
            </el-input>
            <img class="image-code-img" :src="imageCodeSrc" @click="refreshImageCode">
          </el-form-item>
          <el-form-item label=" " prop="smsCode">
            <el-input v-model.trim="devredisterForm.smsCode" autocomplete="off" placeholder="验证码" :maxlength="10">
              <i slot="prefix" class="el-input__icon icon-my-validcode"></i>
            </el-input>
            <el-button class="sendcode" @click="sendCode" :disabled="!show" type="text">{{ showCount }}</el-button>
          </el-form-item>
          <el-form-item label=" " prop="password">
            <el-input type="password" v-model.trim="devredisterForm.password" autocomplete="off" placeholder="新密码" :maxlength="100" clearable>
              <i slot="prefix" class="el-input__icon icon-my-password"></i>
            </el-input>
          </el-form-item>
          <el-form-item label=" " prop="confirmPassword">
            <el-input type="password" v-model.trim="devredisterForm.confirmPassword" autocomplete="off" placeholder="确认密码" :maxlength="100" clearable>
              <i slot="prefix" class="el-input__icon icon-my-password"></i>
            </el-input>
          </el-form-item>
          <el-form-item label=" " prop="businessContact">
            <el-input v-model.trim="devredisterForm.businessContact" autocomplete="off" placeholder="业务联系人" :maxlength="32" clearable>
              <i slot="prefix" class="el-input__icon icon-my-link"></i>
            </el-input>
          </el-form-item>
          <el-form-item label=" " prop="contactNumber">
            <el-input v-model.trim="devredisterForm.contactNumber" autocomplete="off" placeholder="联系电话" :maxlength="100" clearable>
              <i slot="prefix" class="el-input__icon icon-my-phone"></i>
            </el-input>
          </el-form-item>
          <el-form-item label=" " prop="companyName">
            <el-input v-model.trim="devredisterForm.companyName" autocomplete="off" placeholder="公司名称" :maxlength="100" clearable>
              <i slot="prefix" class="el-input__icon icon-my-company"></i>
            </el-input>
          </el-form-item>
          <el-form-item label=" ">
            <el-input v-model.trim="devredisterForm.companyWebsiteAddress" autocomplete="off" placeholder="公司网址" :maxlength="200" clearable>
              <i slot="prefix" class="el-input__icon icon-my-web"></i>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="protocol">
          <el-checkbox v-model="checked">我已阅读并同意</el-checkbox>
          <a @click="viewProtocol()">《开发者协议》</a>
        </div>
        <el-button class="devredister_btn" @click="submitForm('devredisterForm')" @keyup.enter.native="submitForm('devredisterForm')">提交</el-button>
        <div class="login-now"><a @click="$router.push({name:'frontlogin'})">立即登录</a></div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import smsImageCodeMixin from '@/mixins/smsImageCodeMixin'
import commonService from '@/service/commonService'

export default {
  mixins: [smsImageCodeMixin],
  data: function () {
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      }
      if (value && (value.replace(/^\s+|\s+$/gm, '').length < 6 || value.replace(/^\s+|\s+$/gm, '').length > 18)) {
        callback(new Error('密码长度为6-18位'))
      }
      if (value !== this.devredisterForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      checked: true,
      devredisterForm: {
        mobile: '',
        imageCode: '',
        smsCode: '',
        password: '',
        confirmPassword: '',
        businessContact: '',
        contactNumber: '',
        companyName: '',
        companyWebsiteAddress: ''
      },
      rules: {
        mobile: [
          { required: true, message: '请输入登录手机号码', trigger: 'blur' },
          { validator: this.$rules.phoneNumber, trigger: 'blur' }
        ],
        imageCode: [
          { required: true, message: '请输入图形验证码', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入正确密码', trigger: 'blur' }],
        businessContact: [{ required: true, message: '请输入业务联系人', trigger: 'blur' }],
        smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        contactNumber: [
          { required: true, message: '请输入业务联系电话', trigger: 'blur' },
          { validator: this.$rules.telephoneNumber, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请输入正确密码', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ],
        companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }]
      }
    }
  },
  name: 'devredister',
  methods: {
    async sendCode () {
      await this.sendSmsCodeWithImage()
    },
    submitForm (formName) {
      if (!this.checked) {
        this.$message.error('请认真阅读开发者协议')
        return true
      }
      this.$refs[formName].validate(async valid => {
        if (valid) {
          try {
            this.$cookie.set('deviceId', this.devredisterForm.mobile)
            delete this.devredisterForm.confirmPassword
            await commonService.devredister(this.devredisterForm)
            this.$message.success('注册成功，等待管理员审核中')
            this.$router.push({ name: 'frontlogin' })
          } catch (e) {
            this.$message.error(e && e.msg)
          }
        } else {
          this.$message.error('请认真检查填写信息')
          return false
        }
      })
    },
    forgetPwd () {
      this.$router.push({ name: 'frontpwd' })
    },
    viewProtocol () {
      let routeData = this.$router.resolve({ name: 'document', query: { activeMenu: 'agreement' } })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style scoped>
  .devredister{
    height: 100%;
    width: 100%;
    background-color: #F6F6F6;
    padding: 60px 0 75px;
  }
  .devredister .devredister_title{
    height:22px;
    padding: 64px 0 79px;
    font-size:22px;
    letter-spacing: 2px;
    text-align: center;
    font-family:MicrosoftYaHei;
    font-weight:600;
    color:rgba(51,51,51,1);
  }
  .devredister .devredister-content{
    width: 1200px;
    min-height: 700px;
    background-color: #ffffff;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    box-shadow:0px 5px 10px 0px rgba(0, 0, 0, 0.08);
  }
  .devredister .devredister-content .devredister_form_wrapper{
    width: 380px;
    margin: 0 auto;
    text-align: right;
  }
  .devredister * {
    color: #333333;
  }
  .devredister .devredister-content .devredister_form_wrapper .devredister_btn {
    color: #FFFEFE;
    width: 360px;
    height: 40px;
    background: rgba(16, 142, 233, 1);
    border-radius: 6px;
    border-color: transparent;
    margin-bottom: 20px;
  }
  .devredister .devredister-content  .sendcode {
    color:#108EE9!important;
    font-size:14px;
    font-family:MicrosoftYaHei;
    font-weight:400;
    background: transparent;
    width: 110px;
    position: absolute;
    top: 0px;
    text-align: right;
    right: 20px;
  }
  .devredister .devredister-content .sendcode.is-disabled{
    color:#999999!important;
  }
  .devredister .devredister-content .image-code-item{
    position: relative;
  }
  .devredister .devredister-content .image-code-img{
    width: 120px;
    height: 34px;
    position: absolute;
    top: 3px;
    right: 20px;
    border-radius: 4px;
    cursor: pointer;
  }
  .devredister .devredister-content .protocol{
    color: #999999;
    text-align: left;
    margin-bottom: 22px;
    padding-left: 20px;
  }
  .devredister .devredister-content .protocol>a{
    color: #108EE9;
    text-decoration: none;
    cursor: pointer;
  }
</style>
<style type="text/css">
  .devredister .devredister-content .protocol .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #999999;
  }
  .devredister .devredister-content .protocol .el-checkbox__label{
    color: #999999;
  }
  .devredister .login-now{
    width: 360px;
    display: inline-block;
    text-align: right;
    font-size:12px;
    color:rgba(51,51,51,1);
    margin-bottom: 111px;
  }
  .devredister .login-now a{
    font-size:14px;
    font-family:MicrosoftYaHei;
    font-weight:400;
    color:rgba(16,142,233,1);
    text-decoration: none;
    cursor: pointer;
  }
</style>
<style type="text/css">
  .devredister .devredister-content   .el-form-item.is-success .el-input__inner,
  .devredister .devredister-content   .el-form-item.is-success .el-textarea__inner{
    border-color:#D6D6D6;
  }
  .devredister .devredister-content  .el-form-item .el-input__inner:focus,
  .devredister .devredister-content   .el-form-item .el-textarea__inner:focus{
    background:rgba(255,255,255,1);
    border:1px solid rgba(16,142,233,1);
    box-shadow:0px 0px 10px 0px rgba(16,142,233,0.3);
    border-radius:6px;
  }
  .devredister .devredister-content   .el-form-item__error{
    color: #f56c6c;
    font-size: 12px;
    padding-top: 0px;
    position: absolute;
    line-height: 40px;
    height: 40px;
    top:0;
    left: 380px;
    width: 200px;
    text-align: left;
  }
  .devredister .devredister-content .el-input--prefix .el-input__inner{
    padding-left: 35px;
  }
  .devredister .devredister-content  .validcode span.el-input__prefix{
    line-height:40px;
  }
  .devredister .devredister-content .el-checkbox__input.is-checked .el-checkbox__inner,
  .devredister .devredister-content .el-checkbox__inner:hover,
  .devredister .devredister-content .el-checkbox__inner:focus,
  .devredister .devredister-content .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: transparent;
    border-color: #999999;
  }
  .devredister .devredister-content .el-checkbox__input.is-checked .el-checkbox__inner::after{
    color: #999999;
    border-color: #999999;
  }
  .devredister .devredister-content .el-checkbox__inner{
    border-color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/pages/front/dev-register/index.vue